import { FC, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, Outlet, Navigate } from "react-router-dom";
import "./App.css";
import Dashboard from "./components/Dashboard/Dashboard";
import { JurisageDataAPI } from "./lib/JurisageDataAPI";
import { MyJrContextProvider } from "./lib/MyJrContext";
import { AuthProvider } from "./utils/hooks/UseAuth";
import Payment from "src/components/Payment/Payment";

function App() {
  const [context] = useState({
    api: new JurisageDataAPI(),
  });

  return (
    <AuthProvider>
      <MyJrContextProvider value={context}>
        <BrowserRouter basename="dashboard">
          <Routes>
            <Route path="payment" element={<Payment />} />
            <Route path="register" element={<Navigate to="/" />} />
            <Route path="login" element={<Navigate to="/" />} />
            <Route path="/" element={<Layout />}>
              <Route index element={<Dashboard />} />
              <Route path=":citationId" element={<Dashboard />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </MyJrContextProvider>
    </AuthProvider>
  );
}

const Layout: FC = () => {
  return (
    <div className="App">
      {/* A "layout route" is a good place to put markup you want to
                share across all the pages on your site, like navigation. */}
      <div className="Main">
        {/* An <Outlet> renders whatever child route is currently active,
                so you can think about this <Outlet> as a placeholder for
                the child routes we defined above. */}
        <Outlet />
      </div>
    </div>
  );
};

export default App;
